import { useEffect, useState } from 'react';
import { useSessionWarning } from '../../hooks/useSessionWarning';

export const SessionWarningBanner = () => {
  const { showWarning, minutesLeft, isRenewing, renewed, renewNow, dismiss } = useSessionWarning();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (showWarning || renewed) {
      const t = requestAnimationFrame(() => setVisible(true));
      return () => cancelAnimationFrame(t);
    } else {
      setVisible(false);
    }
  }, [showWarning, renewed]);

  if (!showWarning && !renewed) return null;

  return (
    <div
      className={`fixed top-3 left-1/2 -translate-x-1/2 z-[9998] flex justify-center pointer-events-none transition-all duration-300 w-full max-w-md px-4 ${
        visible ? 'opacity-100 translate-y-0' : 'opacity-0 -translate-y-3'
      }`}
    >
      <div
        className={`pointer-events-auto w-full flex items-center gap-3 rounded-xl border px-4 py-3 transition-colors ${
          renewed
            ? 'bg-emerald-50 border-emerald-200'
            : 'bg-amber-50 border-amber-200'
        }`}
      >
        {/* Icon */}
        <div
          className={`w-8 h-8 flex items-center justify-center shrink-0 rounded-lg ${
            renewed ? 'bg-emerald-100' : 'bg-amber-100'
          }`}
        >
          <i
            className={`text-base ${
              renewed
                ? 'ri-shield-check-line text-emerald-600'
                : isRenewing
                ? 'ri-loader-4-line animate-spin text-amber-600'
                : 'ri-time-line text-amber-600'
            }`}
          />
        </div>

        {/* Text */}
        <div className="flex-1 min-w-0">
          {renewed ? (
            <>
              <p className="text-sm font-600 text-emerald-800 leading-snug">
                Sessão renovada com sucesso
              </p>
              <p className="text-xs text-emerald-600 leading-snug mt-0.5">
                Você pode continuar usando normalmente.
              </p>
            </>
          ) : (
            <>
              <p className="text-sm font-600 text-amber-800 leading-snug">
                {minutesLeft === 1
                  ? 'Sua sessão expira em menos de 1 minuto'
                  : `Sua sessão expira em ${minutesLeft} minuto${(minutesLeft ?? 0) > 1 ? 's' : ''}`}
              </p>
              <p className="text-xs text-amber-600 leading-snug mt-0.5">
                Renove agora para não perder o que está fazendo.
              </p>
            </>
          )}
        </div>

        {/* Actions */}
        {!renewed && (
          <div className="flex items-center gap-2 shrink-0">
            <button
              onClick={renewNow}
              disabled={isRenewing}
              className="flex items-center gap-1.5 text-xs font-600 px-3 py-1.5 bg-amber-500 hover:bg-amber-600 disabled:opacity-60 text-white rounded-lg cursor-pointer whitespace-nowrap transition-colors"
            >
              {isRenewing && <i className="ri-loader-4-line animate-spin text-xs" />}
              {isRenewing ? 'Renovando...' : 'Renovar agora'}
            </button>
            <button
              onClick={dismiss}
              className="w-6 h-6 flex items-center justify-center text-amber-500 hover:text-amber-700 cursor-pointer rounded-md hover:bg-amber-100 transition-colors"
              aria-label="Fechar aviso"
            >
              <i className="ri-close-line text-sm" />
            </button>
          </div>
        )}
      </div>
    </div>
  );
};
